import {
  AfterContentInit,
  Component,
  ContentChildren,
  Input,
  OnDestroy,
  QueryList,
  ViewChild
} from '@angular/core';
import { MatColumnDef, MatTable } from '@angular/material/table';
import { Action } from '@app/core/models/forms.model';
import { InfoItem } from '@app/shared/components/info-panel/info-panel.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-management-list',
    templateUrl: './management-list.component.html',
    styleUrls: ['./management-list.component.scss'],
    standalone: false
})
export class ManagementListComponent implements AfterContentInit, OnDestroy {
  @ViewChild(MatTable, { static: true }) table: MatTable<unknown>;
  @ContentChildren(MatColumnDef, { descendants: true }) projectedColumns: QueryList<MatColumnDef>;

  @Input() headerTitle: string;
  @Input() headerSubtitle: string;
  @Input() infoPanelData: InfoItem;
  @Input() subtitle: string;
  @Input() tableActions: Action[] = [];
  @Input() dataSource: unknown;
  @Input() displayedColumns: string[] = [];
  @Input() defaultSort: { column: string; direction: 'asc' | 'desc' | '' };
  @Input() matSortDisableClear = false;
  @Input() showEmptyState = false;

  private projectedColumnsSub: Subscription;
  private registeredColumnDefs: MatColumnDef[] = [];

  ngAfterContentInit(): void {
    this.syncProjectedColumns();
    this.projectedColumnsSub = this.projectedColumns.changes.subscribe(() => {
      this.syncProjectedColumns();
    });
  }

  ngOnDestroy(): void {
    this.projectedColumnsSub?.unsubscribe();
    this.registeredColumnDefs.forEach((columnDef) => this.table.removeColumnDef(columnDef));
  }

  private syncProjectedColumns(): void {
    // Register projected column definitions explicitly so wrapped mat-table
    // reliably resolves displayedColumns during runtime checks.
    this.registeredColumnDefs.forEach((columnDef) => this.table.removeColumnDef(columnDef));
    this.registeredColumnDefs = [];

    this.projectedColumns.forEach((columnDef) => {
      this.table.addColumnDef(columnDef);
      this.registeredColumnDefs.push(columnDef);
    });
  }
}
